import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useMsal } from '../composition-api/useMsal';
import WelcomeName from './WelcomeName.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignOutButton',
  setup(__props) {

const { instance } = useMsal();

const logoutRedirect = () => {
  instance.logoutRedirect();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      href: "",
      onClick: logoutRedirect,
      class: "inline-block leading-8 p-2 text-white hover:bg-purple align-bottom"
    }, "Logout"),
    _createVNode(WelcomeName)
  ], 64))
}
}

})